import type { StatCard } from '../../types'
import { cn } from '../../utils/cn'
import { ClockGlyph } from './ClockGlyph'

type StatGlyphProps = Pick<StatCard, 'icon' | 'glyphSize' | 'flipped' | 'glyphInset'>

export const StatGlyph = ({ icon, glyphSize, flipped, glyphInset }: StatGlyphProps) => {
  if (icon === 'clock') return <ClockGlyph size={glyphSize} />

  return (
    <span className="relative block overflow-hidden" style={{ width: glyphSize, height: glyphSize }}>
      <span
        className={cn('absolute block', flipped && '-scale-y-100')}
        style={{ inset: glyphInset ?? '0' }}
      >
        <img alt="" aria-hidden className="block size-full max-w-none" src={icon} />
      </span>
    </span>
  )
}
